

import { Component, Prop, Vue } from 'vue-property-decorator';
import { CorporateEliot, ApplicationEliot } from '~/interfaces/user.interface';

@Component
export default class ContentThirdApp extends Vue {
    @Prop({}) readonly app!: CorporateEliot | ApplicationEliot ;

}
